import styles from './search-filter.module.css';
export default function SearchFilter(props: 
		{brandAgg: IBrandAgg[],
			priceAgg: any[],
			query: string | undefined,
			totalRows: number,
			setValidPriceRanges: Function,
			validPriceRanges: any[],
			validBrands: string[],
			setValidBrands: Function
			defaultSortOrder: string
			setDefaultSortOrder: Function
		}) {
	return (
		<>
		<div className={styles.searchFilterContainer}>
			<section>
				Søkeord <em>"{props.query}"</em><br/>
				Antall treff <strong>{props.totalRows}</strong>
			</section>
			<br/>
			<section>
				<div className={styles.header}>Sortering</div>
				<select onChange={(e) => {
					e.stopPropagation();
					const sortOrder = e.target.value.toString();
					props.setDefaultSortOrder(sortOrder);
				}}>
					<option value="relevance">Mest relevant</option>
					<option value="priceASC">Pris lav til høy</option>
					<option value="priceDESC">Pris høy til lav</option>
				</select>
			</section>
			<br/>
			<section>
				<div  className={styles.header}>Pris</div>			
				{props.priceAgg.map((agg: any, index: number) => {
					return (
						<div key={agg?.id + index.toString()}>
							<input type="checkbox" id={agg._id}  name={agg._id} onChange={(() => {
								if (props.validPriceRanges.findIndex((r: {min: number, max: number}) => r.min === agg._id) > -1) {
									const newValidPriceRanges = props.validPriceRanges.filter((range: any) => range.min !== agg._id);
									props.setValidPriceRanges(newValidPriceRanges);
								} else {
									props.setValidPriceRanges([...props.validPriceRanges, {
										min: agg._id,
										max: props.priceAgg[index + 1]?._id - 1 || 990000
									}]);
								}
							})} />
							<label className={styles.aggLabel} htmlFor={agg._id} >{agg._id} - {props.priceAgg[index + 1]?._id - 1 || ''} ({agg.count})</label>
						</div>
					)
				})}				
			</section>
			<br/>	
			<section>
				<div  className={styles.header}>Merker</div>
				<div className={styles.filterWrapper}>
					{props.brandAgg
					.map((agg: any, index: number) => {
						return (
							<div key={agg?.id + index.toString()}>
								<input type="checkbox" checked={props.validBrands.indexOf(agg._id) > -1} id={agg._id}  name={agg._id} onChange={() => {
									if (props.validBrands.findIndex((r: string) => r === agg._id) > -1) {
										const newValidBrands = props.validBrands.filter((a: string) => a !== agg._id);
										props.setValidBrands(newValidBrands);
									} else {
										props.setValidBrands([...props.validBrands, agg._id]);
									}
								}} />
								<label className={styles.aggLabel} htmlFor={agg._id} >{`${agg._id.substring(0,1).toUpperCase()}${agg._id.substring(1,agg._id.length).toLowerCase()}`} ({agg.numberOfProducts})</label>
							</div>
						)
					})}
				</div>
			</section>
			<br/>
			<br/>
				
			<br/>
			<br/>

		</div>
		</>
	)
}

export interface IBrandAgg {
	_id: string,
	numberOfProducts: number
} 